var sw = window.innerWidth;
var sh = window.innerHeight;
var header = document.querySelector("header");
var sticky = 0;

// Font Resizer ------------------- Start
function fontResizer() {
  var perc = parseInt(sw) / 120;
  document.body.style.fontSize = perc + "px";
}

// Loader ------------------- Start
function pageLoader() {
  // document.querySelector("html").classList.add("loadjs");
  setTimeout(function () {
    if (document.querySelector(".loader-first")) {
      document.querySelector(".loader-first").style.display = "none";
      document.querySelector("html").classList.remove("loadjs");
    }
  }, 2300);
}

// Window on Load ----------------- Start
window.onload = function () {
  pageLoader();
  if (sw > 1199) {
    fontResizer();
  }
};

// Window On Resize ----------------- Start
(function () {
  window.addEventListener("resize", (event) => {
    sw = window.innerWidth;
    sh = window.innerHeight;
    if (sw > 1025) {
      if (sw < 1400 && sw > 1300 && sh > 900) {
      } else {
        fontResizer();
      }
    }
  });
})();

// Landscape Mode off ---------------- Start
const mql = window.matchMedia("(orientation:landscape)");
mql.addEventListener("change", (event) => {
  if (event.matches) {
    if (innerWidth < 930) {
      // console.log("Now in landscape orientation");
      document.getElementById("portrait-warning").style.display = "flex";
    }
  } else {
    // console.log("Now in portrait orientation");
    document.getElementById("portrait-warning").style.display = "none";
  }
});

// Sticky Header ---------------- Start
(function () {
  if (document.querySelector(".header")) {
    function stickyHeader() {
      if (window.pageYOffset > sticky) {
        header.classList.add("sticky");
      } else {
        header.classList.remove("sticky");
      }
    }
    window.addEventListener("scroll", (event) => {
      stickyHeader();
    });
  }
})();

// SVG Convert Code
window.addEventListener("load", function () {
  (function () {
    if (document.querySelector(".svg-convert")) {
      let svgs = document.querySelectorAll("img.svg-convert");
      svgs.forEach((el) => {
        const imgID = el.getAttribute("id");
        const imgClass = el.getAttribute("class");
        const imgURL = el.getAttribute("src");

        fetch(imgURL)
          .then((response) => response.text())
          .then((data) => {
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(data, "text/html");
            let svg = xmlDoc.querySelector("svg");
            if (typeof imgID !== "undefined") {
              svg.setAttribute("id", imgID);
            }

            if (typeof imgClass !== "undefined") {
              svg.setAttribute("class", imgClass + " svg-converted");
            }

            svg.removeAttribute("xmlns:a");

            el.parentNode.replaceChild(svg, el);
          });
      });
    }
  })();
});

// animate Observer------------Start
(function () {
  if (window.innerWidth > 767) {
    let anim = [...document.querySelectorAll(".animate")];

    let options = {
      rootMargin: "0px",
      threshold: 0.2,
    };

    let animate = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.style.animation = `anim 1s ${entry.target.dataset.delay} forwards ease-out`;
        }
      });
    };

    let observer = new IntersectionObserver(animate, options);

    anim.forEach((item, idx) => {
      observer.observe(item);
    });
  }
})();

// Lazy Load Img observer
(function () {
  document.addEventListener("DOMContentLoaded", () => {
    const imgElements = document.querySelectorAll("img[data-src]");

    const lazyLoadingImage = (entries, observer2) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.src = entry.target.dataset.src;
        entry.target.addEventListener("load", () => {
          entry.target.classList.remove("lazy-img");
          observer2.unobserve(entry.target);
        });
      });
    };
    const lazyLoadingObserver = new IntersectionObserver(lazyLoadingImage, {
      threshold: 0,
      rootMargin: "0px 0px 150px 0px",
    });
    imgElements.forEach((img) => lazyLoadingObserver.observe(img));
  });
})();

(function () {
  if (document.querySelector("#toggle")) {
    let toggleMenu = document.querySelector("#toggle");
    let htmlEl = document.querySelector("html");

    toggleMenu.addEventListener("click", (event) => {
      let _this = event.target;
      _this.classList.toggle("active");
      document.querySelector(".navigation").classList.toggle("active");
      document.querySelector(".navigation").classList.toggle("open");

      // Toggle overflow-hidden class on html element
      htmlEl.classList.toggle("overflow-hidden");
    });
  }
})();

if (document.querySelector(".two_col_slider_sec")) {
  var swiperthumb = new Swiper(".two_col_slider_thumb", {
    // spaceBetween: 20,
    // slidesPerView: 1.5,
    slidesPerView: "auto",
    spaceBetween: 0,
    direction: "vertical",
    watchSlidesProgress: true,
    freeMode: false,
    speed: 1500,
  });

  var twoColSlides = new Swiper(".two_col_slider_slides", {
    spaceBetween: 10,
    speed: 1500,
    thumbs: {
      swiper: swiperthumb,
    },
  });

  var swiper = new Swiper(".content_head_wrapper_slider", {
    spaceBetween: 30,
    effect: "fade",
    slidesPerView: 1,
    speed: 1500,
  });

  swiper.controller.control = twoColSlides;
  twoColSlides.controller.control = swiper;
}
if (document.querySelector(".project_slider")) {
  var swiper = new Swiper(".project_slider", {
    slidesPerView: 1,
    spaceBetween: 30,
    speed: 1500,
    breakpoints: {
      575: {
        slidesPerView: 2,
      },
      991: {
        slidesPerView: 3,
      },
      1199: {
        slidesPerView: 3.38,
      },
    },

    pagination: {
      el: ".project_slider .swiper-pagination",
      type: "progressbar",
    },
    navigation: {
      nextEl: ".project_slider .swiper-button-next",
      prevEl: ".project_slider .swiper-button-prev",
    },
  });
}

if (document.querySelector(".distribution_center_sec")) {
  var leftSwiper = new Swiper(".left_col_slider", {
    speed: 1500,
    slidesPerView: 1,
    allowTouchMove: true,
    loop: true,

    spaceBetween: 20,
    pagination: {
      el: ".center_col_slider .progress",
      type: "progressbar",
    },

    effect: "creative",
    creativeEffect: {
      prev: {
        shadow: true,
        translate: ["-20%", 0, -1],
      },
      next: {
        translate: ["100%", 0, 0],
      },
    },
    breakpoints: {
      575: {
        allowTouchMove: false,
      },
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  var centerSwiper = new Swiper(".center_col_slider", {
    speed: 1500,
    slidesPerView: 1,
    spaceBetween: 20,
    allowTouchMove: false,
    effect: "fade",
    loop: true,

    fadeEffect: {
      crossFade: true,
    },
    pagination: {
      el: ".fraction",
      type: "custom",
      renderCustom: function (swiper, current, total) {
        const currentFormatted = current < 10 ? "0" + current : current;
        const totalFormatted = total < 10 ? "0" + total : total;
        return `<span class='current_slide'>${currentFormatted}</span> <span class='slash'>/</span> <span class='total_slide'>${totalFormatted}</span>`;
      },
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });

  var rightSwiper = new Swiper(".right_col_slider", {
    speed: 1500,
    slidesPerView: 1,
    spaceBetween: 20,
    allowTouchMove: false,
    loop: true,

    pagination: {
      el: ".top_fraction .swiper-pagination",
      type: "custom",
      renderCustom: function (swiper, current) {
        return current < 10 ? "0" + current : current;
      },
    },
    effect: "creative",
    creativeEffect: {
      prev: {
        shadow: true,
        translate: ["-20%", 0, -1],
      },
      next: {
        translate: ["100%", 0, 0],
      },
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    // navigation: {
    //   nextEl: ".distribution_center_wrapper .swiper-button-next",
    //   prevEl: ".distribution_center_wrapper .swiper-button-prev",
    // },
    // on: {
    //   slideChange: function () {
    //     const prevButton = document.querySelector(
    //       ".distribution_center_wrapper .swiper-button-prev"
    //     );
    //     if (prevButton) {
    //       if (this.activeIndex === 0) {
    //         prevButton.classList.add("disabled");
    //       } else {
    //         prevButton.classList.remove("disabled");
    //       }
    //     }
    //   },
    // },
  });

  // function syncSliders(sourceSwiper, targetSwipers) {
  //   sourceSwiper.on("slideChange", function () {
  //     targetSwipers.forEach((swiper) => {
  //       if (swiper.activeIndex !== sourceSwiper.activeIndex) {
  //         swiper.slideTo(sourceSwiper.activeIndex);
  //       }
  //     });
  //   });
  // }

  // syncSliders(leftSwiper, [centerSwiper, rightSwiper]);
  // syncSliders(centerSwiper, [leftSwiper, rightSwiper]);
  // syncSliders(rightSwiper, [leftSwiper, centerSwiper]);
}

if (document.querySelector(".stories_thumb_slider")) {
  var swiper = new Swiper(".stories_thumb_slider", {
    spaceBetween: 0,
    slidesPerView: "auto",
    freeMode: false,
    speed: 1500,
    direction: "vertical",
    watchSlidesProgress: true,
  });
}
if (document.querySelector(".stories_content_slider")) {
  var swiper2 = new Swiper(".stories_content_slider", {
    spaceBetween: 10,
    speed: 1500,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: swiper,
    },
  });
}

if (document.querySelector(".industry_verticals_slider")) {
  var swiper3 = new Swiper(".industry_verticals_slider", {
    slidesPerView: 1,
    spaceBetween: 30,
    speed: 1500,
    breakpoints: {
      575: {
        slidesPerView: 2,
      },
      1024: {
        slidesPerView: 2.5,
      },
      1200: {
        slidesPerView: 3.34,
      },
    },
  });
}
// dots slider
if (document.querySelector(".health_content_slider")) {
  var healthContentSlider = new Swiper(".health_content_slider", {
    speed: 1200,
    slidesPerView: 1,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    on: {
      slideChange: function () {
        setTimeout(() => updateDots(healthContentSlider.realIndex), 10);
      },
    },
  });

  const dots = document.querySelectorAll(".dot");

  function updateDots(activeIndex) {
    dots.forEach((dot, index) => {
      if (index === activeIndex) {
        dot.classList.add("highlight");
      } else {
        dot.classList.remove("highlight");
      }
    });
  }

  dots.forEach((dot, index) => {
    dot.addEventListener("click", function () {
      healthContentSlider.slideTo(index);
      healthContentSlider.autoplay.start();
      updateDots(index);
    });
  });

  updateDots(healthContentSlider.realIndex);
}

if (document.querySelector(".awards-slider")) {
  var awardsSlider = new Swiper(".awards-slider", {
    slidesPerView: "auto",
    spaceBetween: 16,
    speed: 1500,
    allowTouchMove: true,
  });
}

if (document.querySelector(".our-fleetSlider")) {
  var ourFleetSlider = new Swiper(".our-fleetSlider", {
    slidesPerView: "auto",
    spaceBetween: 30,
    speed: 1500,
    allowTouchMove: true,
    navigation: {
      nextEl: ".our-fleet .pagination-arrows .swiper-button-next",
      prevEl: ".our-fleet .pagination-arrows .swiper-button-prev",
    },
    scrollbar: {
      el: ".our-fleet .pagination-arrows .swiper-scrollbar",
      hide: true,
    },
  });
}

if (document.querySelector(".high-standardsSlider")) {
  var highStandardsSlider = new Swiper(".high-standardsSlider", {
    slidesPerView: 2,
    spaceBetween: 30,
    speed: 1500,
    allowTouchMove: true,
    navigation: {
      nextEl: ".high-standards .pagination-arrows .swiper-button-next",
      prevEl: ".high-standards .pagination-arrows .swiper-button-prev",
    },
  });
}

if (document.querySelector(".automated-thumbsSlider")) {
  var automatedThumbSlider = new Swiper(".automated-thumbsSlider", {
    slidesPerView: "auto",
    spaceBetween: 30,
    speed: 1500,
    allowTouchMove: true,
  });
}

if (document.querySelector(".automated-slider")) {
  var automatedSlider = new Swiper(".automated-slider", {
    slidesPerView: "auto",
    spaceBetween: 30,
    speed: 1500,
    allowTouchMove: true,
    navigation: {
      nextEl: ".automated-transport .pagination-arrows .swiper-button-next",
      prevEl: ".automated-transport .pagination-arrows .swiper-button-prev",
    },
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    thumbs: {
      swiper: automatedThumbSlider,
    },
  });
}

document.addEventListener("DOMContentLoaded", () => {
  const container = document.querySelector(".seamless-effectWrapper");
  if (!container) return;

  const headings = container.querySelectorAll(".h5");
  const images = container.querySelectorAll(".effect-img");

  if (headings.length === 0 || images.length === 0) return;

  const defaultHeading = headings[0];
  const defaultImage = images[0];

  function setDefaultActive() {
    headings.forEach((h5) => h5.classList.remove("active"));
    images.forEach((img) => img.classList.remove("active"));

    if (defaultHeading) defaultHeading.classList.add("active");
    if (defaultImage) defaultImage.classList.add("active");
  }

  function activateItem(heading) {
    headings.forEach((h5) => h5.classList.remove("active"));
    images.forEach((img) => img.classList.remove("active"));

    heading.classList.add("active");
    const id = heading.dataset.id;
    const matchingImage = container.querySelector(`.effect-img#${id}`);
    if (matchingImage) {
      matchingImage.classList.add("active");
    }
  }

  function setupInteractions() {
    const isMobile = window.matchMedia("(max-width: 576px)").matches;

    headings.forEach((heading) => {
      heading.removeEventListener("mouseenter", hoverHandler);
      heading.removeEventListener("touchstart", touchHandler);
      heading.removeEventListener("click", touchHandler);

      if (isMobile) {
        heading.addEventListener("touchstart", touchHandler);
        heading.addEventListener("click", touchHandler);
      } else {
        heading.addEventListener("mouseenter", hoverHandler);
      }
    });

    if (!isMobile) {
      container.addEventListener("mouseleave", setDefaultActive);
    } else {
      container.removeEventListener("mouseleave", setDefaultActive);
      document.addEventListener("click", outsideClickHandler);
    }

    setDefaultActive();
  }

  function hoverHandler(event) {
    activateItem(event.currentTarget);
  }

  function touchHandler(event) {
    event.preventDefault();
    activateItem(event.currentTarget);
  }

  function outsideClickHandler(event) {
    if (!container.contains(event.target)) {
      setDefaultActive();
    }
  }

  setupInteractions();
  window.addEventListener("resize", setupInteractions);
});

// document.addEventListener("DOMContentLoaded", () => {
//   const container = document.querySelector(".seamless-effectWrapper");
//   if (!container) return;

//   const cards = container.querySelectorAll(".card");
//   if (cards.length === 0) return;

//   cards[0].classList.add("active");

//   cards.forEach((card) => {
//     card.addEventListener("click", function () {
//       cards.forEach((c) => c.classList.remove("active"));
//       this.classList.add("active");
//     });
//   });
// });

document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".generic-tabs li");
  const tabContents = document.querySelectorAll(".individual-tab");

  // Function to activate a tab
  function activateTab(tabId) {
    tabContents.forEach((content) => {
      content.style.display = content.id === tabId ? "block" : "none";
    });

    tabs.forEach((tab) => tab.classList.remove("active"));
    document
      .querySelector(`.generic-tabs li[data-id="${tabId}"]`)
      .classList.add("active");
  }

  // Tab click event
  tabs.forEach((tab) => {
    tab.addEventListener("click", function () {
      const tabId = this.getAttribute("data-id");
      activateTab(tabId);
    });
  });

  // Activate first tab by default
  if (tabs.length > 0) {
    activateTab(tabs[0].getAttribute("data-id"));
  }

  // Check for mobile view
  function handleResize() {
    if (window.innerWidth <= 576) {
      tabs.forEach((tab) => {
        tab.addEventListener("click", function () {
          const tabId = this.getAttribute("data-id");
          activateTab(tabId);
        });
      });
    }
  }

  // Initial check
  handleResize();

  // Add event listener for window resize
  window.addEventListener("resize", handleResize);
});

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".individual-tab").forEach((tab) => {
    const listItems = tab.querySelectorAll(".direct-presence ul li");
    const mapContainers = tab.querySelectorAll(".direct-presenceMap .map-img");
    const extraImages = tab.querySelectorAll(".extra-img");

    // Set the default active map image for this tab
    const defaultMap = tab.querySelector(
      ".direct-presenceMap .map-img:not([data-id])"
    );
    if (defaultMap) {
      defaultMap.classList.add("active");
    }

    const activateItem = (item) => {
      listItems.forEach((li) => li.classList.remove("active"));
      mapContainers.forEach((container) =>
        container.classList.remove("active")
      );
      extraImages.forEach((img) => img.classList.remove("active"));

      item.classList.add("active");

      const id = item.dataset.id;

      const matchingMap = tab.querySelector(
        `.direct-presenceMap .map-img[data-id="${id}"]`
      );
      const matchingExtraImg = tab.querySelector(`.extra-img[data-id="${id}"]`);

      if (matchingMap) {
        matchingMap.classList.add("active");
      } else if (defaultMap) {
        defaultMap.classList.add("active");
      }

      if (matchingExtraImg) {
        matchingExtraImg.classList.add("active");
      }
    };

    // ✅ Reusable function to handle hover effect
    const hoverItem = (item) => {
      const id = item.dataset.id;

      // Remove hover-img class from all items
      listItems.forEach((li) => li.classList.remove("hover-img"));
      mapContainers.forEach((container) =>
        container.classList.remove("hover-img")
      );
      extraImages.forEach((img) => img.classList.remove("hover-img"));

      // Add hover-img class to the hovered item and corresponding map/extra image
      item.classList.add("hover-img");

      const matchingMap = tab.querySelector(
        `.direct-presenceMap .map-img[data-id="${id}"]`
      );
      const matchingExtraImg = tab.querySelector(`.extra-img[data-id="${id}"]`);

      if (matchingMap) {
        matchingMap.classList.add("hover-img");
      }
      if (matchingExtraImg) {
        matchingExtraImg.classList.add("hover-img");
      }
    };

    // ✅ Apply click, mouseenter, and mouseleave events
    listItems.forEach((item) => {
      // Click event for activation
      item.addEventListener("click", () => activateItem(item));

      // Mouseenter event for hover effect
      item.addEventListener("mouseenter", () => hoverItem(item));

      // Mouseleave event to remove hover effect
      item.addEventListener("mouseleave", () => {
        item.classList.remove("hover-img");
        mapContainers.forEach((container) =>
          container.classList.remove("hover-img")
        );
        extraImages.forEach((img) => img.classList.remove("hover-img"));

        // Restore active state if any
        const activeItem = tab.querySelector(".direct-presence ul li.active");
        if (activeItem) {
          const activeMap = tab.querySelector(
            `.direct-presenceMap .map-img[data-id="${activeItem.dataset.id}"]`
          );
          const activeExtraImg = tab.querySelector(
            `.extra-img[data-id="${activeItem.dataset.id}"]`
          );

          if (activeMap) activeMap.classList.add("active");
          if (activeExtraImg) activeExtraImg.classList.add("active");
        } else if (defaultMap) {
          defaultMap.classList.add("active");
        }
      });
    });

    // ✅ Reset to default on clicking outside the list
    document.addEventListener("click", (event) => {
      if (!event.target.closest(".direct-presence ul li")) {
        listItems.forEach((li) => li.classList.remove("active", "hover-img"));
        mapContainers.forEach((container) =>
          container.classList.remove("active", "hover-img")
        );
        extraImages.forEach((img) =>
          img.classList.remove("active", "hover-img")
        );

        if (defaultMap) {
          defaultMap.classList.add("active");
        }
      }
    });
  });
});

if (document.querySelector(".heritageSliderSec")) {
  let timelineSlider = new Swiper(".timelineSlider", {
    slidesPerView: "auto",
  });

  var timelineDetailSlider = new Swiper(".timelineDetailSlider", {
    spaceBetween: 10,
    slidesPerView: "auto",
    speed: 3000,
    thumbs: {
      swiper: timelineSlider,
    },
  });
}

const tabs = document.querySelectorAll(".tabs");
const tabdet = document.querySelectorAll(".tab-det");

// Function to open the first accordion in the active tab
function openFirstAccordion(tabContent) {
  const firstAccordion = tabContent.querySelector(".acc-container");
  if (firstAccordion) {
    const firstContent = firstAccordion.querySelector(".acc_content");
    firstAccordion.classList.add("active");
    if (firstContent) {
      firstContent.style.maxHeight = firstContent.scrollHeight + "px";
    }
  }
}

// Function to activate the tab based on its ID
function activateTab(tabId) {
  tabs.forEach((tab) => {
    tab.classList.toggle("active", tab.id === tabId);
  });

  tabdet.forEach((content) => {
    const isActive = content.id === tabId;
    content.style.display = isActive ? "block" : "none";

    if (isActive) {
      // Close all accordions in other tabs
      document.querySelectorAll(".acc-container").forEach((acc) => {
        acc.classList.remove("active");
        const accContent = acc.querySelector(".acc_content");
        if (accContent) accContent.style.maxHeight = "0px";
      });

      // Open the first accordion in the active tab
      openFirstAccordion(content);
    }
  });
}

// Check for 'country' parameter in the URL
const urlParams = new URLSearchParams(window.location.search);
const countryParam = urlParams.get("country");

// Activate the corresponding tab if found, otherwise default to the first tab
if (countryParam && document.getElementById(countryParam)) {
  activateTab(countryParam);
} else if (tabs.length > 0) {
  activateTab(tabs[0].id); // Default to the first tab
}

// Check if the URL contains 'contact-us.php?' followed by any query parameter
if (
  window.location.href.includes("/contact-us/?") ||
  window.location.href.includes("/contact-us?")
) {
  const branchesSection = document.getElementById("branches");
  if (branchesSection) {
    branchesSection.scrollIntoView({ behavior: "smooth" });
  }
}

// Event listener for manual tab clicks
tabs.forEach((tab) => {
  tab.addEventListener("click", function () {
    activateTab(tab.id);
  });
});

(function () {
  const faqWrappers = document.querySelectorAll(".acc_wrapper");

  faqWrappers.forEach((wrapper) => {
    const faqContainers = wrapper.querySelectorAll(".acc-container");

    faqContainers.forEach((container) => {
      const header = container.querySelector(".acc_head");
      const content = container.querySelector(".acc_content");

      if (header && content) {
        // Add smooth transition
        content.style.maxHeight = "0px"; // Ensure it's collapsed initially

        header.addEventListener("click", function () {
          // Close all other accordions in the same wrapper
          faqContainers.forEach((otherContainer) => {
            if (otherContainer !== container) {
              otherContainer.classList.remove("active");
              const otherContent = otherContainer.querySelector(".acc_content");
              if (otherContent) otherContent.style.maxHeight = "0px";
            }
          });

          // Toggle current accordion
          container.classList.toggle("active");
          content.style.maxHeight = container.classList.contains("active")
            ? content.scrollHeight + "px"
            : "0px";
        });
      }
    });

    // Open the first accordion by default
    const firstContainer = wrapper.querySelector(".acc-container");
    if (firstContainer) {
      const firstContent = firstContainer.querySelector(".acc_content");
      firstContainer.classList.add("active");
      if (firstContent)
        firstContent.style.maxHeight = firstContent.scrollHeight + "px";
    }
  });
})();

document.addEventListener("DOMContentLoaded", function () {
  const searchWrapper = document.querySelector(".search-wrapper");
  const searchPopup = document.querySelector(".search-popup");
  const crossIcon = document.querySelector(".cross-icon");

  // Check if elements exist before proceeding
  if (searchWrapper && searchPopup && crossIcon) {
    // Open search popup on search-wrapper click
    searchWrapper.addEventListener("click", function () {
      searchPopup.classList.add("open");
    });

    // Close search popup on cross-icon click
    crossIcon.addEventListener("click", function () {
      searchPopup.classList.remove("open");
    });

    // Optional: Close on ESC key press
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") {
        searchPopup.classList.remove("open");
      }
    });
  }
});

if (document.querySelector(".reliable-infrastructureSlider")) {
  var reliableInfrastructureSlider = new Swiper(
    ".reliable-infrastructureSlider",
    {
      loop: true,
      speed: 1000,
      autoplay: {
        delay: 3000,
      },
      effect: "coverflow",
      grabCursor: true,
      centeredSlides: true,
      slidesPerView: "auto",
      coverflowEffect: {
        rotate: 0,
        stretch: 80,
        depth: 200,
        modifier: 1,
        slideShadows: false,
      },
      pagination: {
        el: ".reliable-infrastructureSlider .swiper-pagination",
      },
    }
  );
}

if (document.querySelector(".our-teamSlider")) {
  var ourTeamSlider = new Swiper(".our-teamSlider", {
    slidesPerView: 1,
    allowTouchMove: true,
    watchSlidesProgress: true,
    speed: 2000,
    allowTouchMove: true,
    spaceBetween: 30,
    breakpoints: {
      575: {
        slidesPerView: 3,
      },
      1100: {
        slidesPerView: "auto",
      },
    },
    navigation: {
      nextEl: ".our-team .pagination-arrows .swiper-button-next",
      prevEl: ".our-team .pagination-arrows .swiper-button-prev",
    },
    scrollbar: {
      el: ".our-team .pagination-arrows .swiper-scrollbar",
      hide: true,
    },
  });
}

if (document.querySelector(".our-strengthsThumb")) {
  var ourStrengthsThumb = new Swiper(".our-strengthsThumb", {
    slidesPerView: "auto",

    allowTouchMove: true,
    threshold: 10,
    direction: "vertical",
    breakpoints: {
      575: {
        slidesPerView: "auto",
      },
      1100: {
        allowTouchMove: false,
      },
    },
  });
}

if (document.querySelector(".our-strengthsDetail")) {
  var ourStrengthsDetail = new Swiper(".our-strengthsDetail", {
    slidesPerView: 1,
    spaceBetween: 30,

    allowTouchMove: false,
    thumbs: {
      swiper: ourStrengthsThumb,
    },
  });
}

document.addEventListener("DOMContentLoaded", () => {
  const headings = document.querySelectorAll(".vision-mission .inner-wrapperr");
  const images = document.querySelectorAll(".vision-mission .img-wrapper");

  // Set the default active heading and image
  const defaultHeading = headings[0];
  const defaultImage = images[0];

  if (defaultHeading) {
    defaultHeading.classList.add("active");
  }
  if (defaultImage) {
    defaultImage.classList.add("active");
  }

  headings.forEach((heading) => {
    heading.addEventListener("mouseenter", () => {
      // Remove active class from all headings and images
      headings.forEach((item) => item.classList.remove("active"));
      images.forEach((img) => img.classList.remove("active"));

      // Add active class to the hovered heading
      heading.classList.add("active");

      // Get the ID from the data attribute
      const id = heading.dataset.id;

      // Show the matching image
      const matchingImage = document.querySelector(
        `.vision-mission .img-wrapper#${id}`
      );
      if (matchingImage) {
        matchingImage.classList.add("active");
      }
    });
  });

  // Reset to default on mouse leave from the container if it exists
  const customRow = document.querySelector(".vision-mission .custom-row");
  if (customRow) {
    customRow.addEventListener("mouseleave", () => {
      headings.forEach((item) => item.classList.remove("active"));
      images.forEach((img) => img.classList.remove("active"));

      if (defaultHeading) {
        defaultHeading.classList.add("active");
      }
      if (defaultImage) {
        defaultImage.classList.add("active");
      }
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const cards = document.querySelectorAll(".impact_card");

  function activateCard(tabId) {
    cards.forEach((card) => {
      if (card.dataset.tab === tabId) {
        card.classList.add("active");
      } else {
        card.classList.remove("active");
      }
    });
  }

  if (window.location.hash) {
    const tabId = window.location.hash.substring(1);
    activateCard(tabId);
  } else {
    if (cards.length > 0) {
      cards[0].classList.add("active");
    }
  }

  cards.forEach((card) => {
    card.addEventListener("click", function () {
      activateCard(this.dataset.tab);
    });
  });

  window.addEventListener("hashchange", function () {
    const tabId = window.location.hash.substring(1);
    activateCard(tabId);
  });
});

// document.querySelectorAll(".mobileToggle").forEach((toggle) => {
//   toggle.addEventListener("click", function () {
//     // Remove active and opened classes from all other toggles and menus
//     document.querySelectorAll(".mobileToggle").forEach((item) => {
//       if (item !== this) {
//         item.classList.remove("active");
//         item.nextElementSibling.classList.remove("opened");
//         item.nextElementSibling.style.maxHeight = null;
//       }
//     });

//     // Toggle active class on the clicked toggle
//     this.classList.toggle("active");

//     // Toggle max-height and opened class of the next sibling (inner-menu)
//     const innerMenu = this.nextElementSibling;
//     if (innerMenu.style.maxHeight) {
//       innerMenu.style.maxHeight = null; // Collapse the menu
//       innerMenu.classList.remove("opened");
//     } else {
//       innerMenu.style.maxHeight = innerMenu.scrollHeight + "px"; // Expand the menu
//       innerMenu.classList.add("opened");
//     }
//   });
// });





document.querySelectorAll(".menu__menuitem--menulink, .mobileToggle").forEach((toggle) => {
  toggle.addEventListener("click", function (event) {

    const parentLi = this.closest(".menu__menuitem.has-child");
    const mobileToggle = parentLi.querySelector(".mobileToggle");
    const innerMenu = parentLi.querySelector(".mega-menu");

    // Remove active and opened classes from all other toggles and menus
    document.querySelectorAll(".menu__menuitem.has-child").forEach((item) => {
      if (item !== parentLi) {
        item.classList.remove("active");
        item.querySelector(".mega-menu").classList.remove("opened");
        item.querySelector(".mega-menu").style.maxHeight = null;
        item.querySelector(".mobileToggle").classList.remove("active");
      }
    });

    // Toggle active class on the clicked toggle
    mobileToggle.classList.toggle("active");

    // Toggle max-height and opened class of the menu
    if (innerMenu.style.maxHeight) {
      innerMenu.style.maxHeight = null; // Collapse the menu
      innerMenu.classList.remove("opened");
    } else {
      innerMenu.style.maxHeight = innerMenu.scrollHeight + "px"; // Expand the menu
      innerMenu.classList.add("opened");
    }
  });
});


if (document.querySelector(".warehouse-imageSlider")) {
  var warehouseImageSlider = new Swiper(".warehouse-imageSlider", {
    slidesPerView: 1,
    spaceBetween: 30,
    speed: 1500,
    effect: "fade",
    threshold: 10,
    draggable: false,
    fadeEffect: {
      crossFade: true,
    },
    allowTouchMove: false,
  });
}

if (document.querySelector(".warehouse-thumbSlider")) {
  var warehouseThumbSlider = new Swiper(".warehouse-thumbSlider", {
    slidesPerView: 1.1,
    speed: 1500,
    spaceBetween: 10,

    slideToClickedSlide: true,
    allowTouchMove: true,
    loop: true,
    breakpoints: {
      575: {
        slidesPerView: "auto",
        spaceBetween: 30,
      },
      1100: {
        allowTouchMove: false,
      },
    },
  });
}

if (document.querySelector(".warehouse-detailSlider")) {
  var warehouseDetailSlider = new Swiper(".warehouse-detailSlider", {
    slidesPerView: 1,
    spaceBetween: 30,
    speed: 1500,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    allowTouchMove: false,
    thumbs: {
      swiper: warehouseThumbSlider,
    },
  });
}

if (warehouseImageSlider && warehouseDetailSlider) {
  warehouseDetailSlider.controller.control = warehouseImageSlider;
}

// if (document.querySelector(".digital-freightSlider")) {
//   var digitalFreightSlider = new Swiper(".digital-freightSlider", {
//     slidesPerView: 1,
//     spaceBetween: 30,
//     speed: 1500,
//     allowTouchMove: true,
//     breakpoints: {
//       575: {
//         slidesPerView: 3,
//       },
//       1024: {
//         slidesPerView: 4,
//       },
//     },
//   });
// }

document.addEventListener("DOMContentLoaded", () => {
  const logo = document.querySelector(".loader-first");
  logo.classList.add("show");
});

document.querySelectorAll(".toggle-btn").forEach((toggle) => {
  toggle.addEventListener("click", function () {
    // Remove active class and max-height from all other toggles and menus
    document.querySelectorAll(".toggle-btn").forEach((item) => {
      if (item !== this) {
        item.classList.remove("active");
        item.nextElementSibling.style.maxHeight = null;
      }
    });

    // Toggle active class on the clicked toggle
    this.classList.toggle("active");

    // Toggle max-height of the next sibling (inner-menu)
    const footerMenu = this.nextElementSibling;
    if (footerMenu.style.maxHeight) {
      footerMenu.style.maxHeight = null; // Collapse the menu
    } else {
      footerMenu.style.maxHeight = footerMenu.scrollHeight + "px"; // Expand the menu
    }
  });
});

function phone_Num() {
  if (document.querySelectorAll(".phoneiti").length > 0) {
    const initializeIntlTelInput = () => {
      const inputs = document.querySelectorAll(".phoneiti");

      inputs.forEach((intll) => {
        const iti = window.intlTelInput(intll, {
          hiddenInput: "full_phone",
          initialCountry: "auto",
          // initialCountry: "ae", // Adjust as needed
          /* For Country Code */
          separateDialCode: true,
          geoIpLookup(callback) {
            fetch("https://ipinfo.io/json")
              .then((response) => response.json())
              .then((data) => callback(data?.country || "us"))
              .catch(() => callback("us")); // Fallback to "us" in case of error
          },
          utilsScript:
            "https://cdn.jsdelivr.net/npm/intl-tel-input@17.0.19/build/js/utils.js",
        });

        // Update the hidden field on input or country change
        intll.addEventListener("input", () => updateHiddenField(iti, intll));
        intll.addEventListener("countrychange", () =>
          updateHiddenField(iti, intll)
        );
      });

      // Function to update the hidden field with the country code + phone number
      const updateHiddenField = (iti, intll) => {
        const fullPhone = iti.getNumber();
        const hiddenInput = intll
          .closest("form")
          .querySelector('[name="full_phone"]');
        if (hiddenInput) {
          hiddenInput.value = fullPhone;
        }
      };
    };

    // Wait until intlTelInput is available
    const checkInterval = setInterval(() => {
      if (typeof window.intlTelInput === "function") {
        clearInterval(checkInterval);
        initializeIntlTelInput();
        console.log("intlTelInput initialized.");
      }
    }, 50); // Check every 50ms
  }
}

phone_Num();

var swiper = new Swiper(".countery_wrapper", {
  slidesPerView: 2.5,
  spaceBetween: 0,
  slideToClickedSlide: true,
  grabCursor: true,
  loop: document.querySelectorAll(".countery_wrapper .swiper-slide").length > 3,

  breakpoints: {
    992: {
      slidesPerView: "auto",
    },
  },
});
document.addEventListener("DOMContentLoaded", function () {
  const tabs = document.querySelectorAll(".generic-tabs li");
  const tabContents = document.querySelectorAll(".individual-tab");

  // Function to activate a tab
  function activateTab(tabId) {
    tabContents.forEach((content) => {
      content.style.display = content.id === tabId ? "block" : "none";
    });

    tabs.forEach((tab) => tab.classList.remove("active"));
    document
      .querySelector(`.generic-tabs li[data-id="${tabId}"]`)
      .classList.add("active");
  }

  // Tab click event
  tabs.forEach((tab) => {
    tab.addEventListener("click", function () {
      const tabId = this.getAttribute("data-id");
      activateTab(tabId);
    });
  });

  // Activate first tab by default
  if (tabs.length > 0) {
    activateTab(tabs[0].getAttribute("data-id"));
  }

  // Check for mobile view
  function handleResize() {
    if (window.innerWidth <= 576) {
      tabs.forEach((tab) => {
        tab.addEventListener("click", function () {
          const tabId = this.getAttribute("data-id");
          activateTab(tabId);
        });
      });
    }
  }

  // Initial check
  handleResize();

  // Add event listener for window resize
  window.addEventListener("resize", handleResize);
});